module.exports = __webpack_public_path__ + "img/Shooting.e5fb2adc.png";